import { Config, makeRequest } from "@paywithglide/glide-js";
import { logger } from "../logger";

export type OnrampQuoteRequest = {
  cryptoAmount: string;
  paymentMethodType: "UPI" | "IMPS";
};

export type OnrampQuoteResponse = {
  fromCurrency: string; // e.g., "INR"
  toCurrency: string; // e.g., "USDT"
  fromAmount: string; // Amount in fiat (INR)
  toAmount: string; // Amount in crypto
  rate: string; // Exchange rate
};

export async function getQuote(
  glideConfig: Config,
  request: OnrampQuoteRequest,
): Promise<OnrampQuoteResponse> {
  try {
    const response = await makeRequest<OnrampQuoteResponse>(glideConfig, {
      url: `/onramp/quote`,
      method: "POST",
      body: request,
    });

    return response;
  } catch (error) {
    logger.error(`Failed to get onramp quote: ${error}`);
    throw error;
  }
}
